import { Dialog, DialogContent } from "@material-ui/core";
import * as React from "react";

const DialogView = ({
  open,
  handleClose,
  dialogContainerClassNameValue,
  dialogContentsClassName,
  dialogBody,
}: any) => {
  return (
    <div className="dialog-contents-container">
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose} className={`${dialogContainerClassNameValue}`}>
        <DialogContent className={`${dialogContentsClassName}`}>{dialogBody}</DialogContent>
      </Dialog>
    </div>
  );
};

export default DialogView;
